exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".date-picker {\n  margin-bottom: 10px;\n  width: 315px;\n  height: 40px;\n  color: #333;\n  background-color: #F9F9F9;\n  border-color: #aaa;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 2px;\n  padding: 5px;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-weight: 600; }\n  .date-picker:focus {\n    outline-color: black;\n    outline-style: solid;\n    outline-width: 1px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/km-date-picker.sass
// module id = 1349
// module chunks = 0